import { makeStyles } from '@material-ui/core';

export default makeStyles(theme => ({
  actionsRow: {
    alignItems: 'stretch',
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(2),
  },
  actionsRowMobile: {
    flexDirection: 'column',
    '& $actionCell': {
      width: '100%',
    },
  },
  actionCell: {
    alignItems: 'stretch',
    display: 'flex',
    flex: '0 1 auto',
    minWidth: 0,
  },
  tooltipTrigger: {
    alignItems: 'stretch',
    display: 'flex',
    flex: 1,
    minWidth: 0,
  },
  stretchButton: {
    alignSelf: 'stretch',
    flex: 1,
    height: '100%',
    lineHeight: 1.25,
    minHeight: theme.spacing(7),
    textAlign: 'center',
    whiteSpace: 'normal',
  },
}));
